
<div class="modal-content">
  <div class="modal-header" >
    <h4 class="modal-title" id="myModalLabel">
      Alterar Item Da Mesa
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="fecheModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div   >
  <div   class="modal-body">
    <div class="mt-t5 mb-5" *ngIf="carregando">
      <i class="k-i-loading k-icon ml-2"></i> carregando ....
    </div>

    <app-tela-adicionar-produto #telaAdicionarProduto  [editandoItemMesa]="true" [hidden]="itemAtualizado || carregando"
                                (onAtualizou)="atualizeProduto($event)"
                                (onCancelouAdicionar)="canceleAdicionar($event)"  >

    </app-tela-adicionar-produto>


    <div class="mt-3 mb-2"  [hidden]="!itemAtualizado" >
      <app-grid-produtos #listaDePedidos [tela]="this" (onEditar)="editeItemPedido($event)"></app-grid-produtos>

      <button class="btn btn-success btn-block mt-2" type="button" [disabled]="alterandoItemPedido"
              (click)="confirmeAlteracaoItemPedido()">
        <i class="k-icon k-i-loading" *ngIf="alterandoItemPedido"></i>Confirmar alteração
      </button>
    </div>


  </div>
</div>
